module.exports = __webpack_public_path__ + "img/types.64ad7997.png";